<template>
  <div>
    <Navigation ref="nav_ref"  @callbackComponent="callbackComponent"/>
    <h1 class="text-hide ny_banner" v-for="(item,index) in banner" :key="index"
        :style="{background:'url('+item.url+') no-repeat center  50%/cover'}">公司简介</h1>
    <router-view></router-view>
    <Footer/>
  </div>
</template>

<script>
import Navigation from '../../components/Navigation'
import Footer from '../../components/Footer'
export default {
  name: 'index',
  provide () {
    return {
      reload: this.reload
    }
  },
  components: {
    Navigation,
    Footer
  },
  data () {
    return {
      banner: [],
      isRouterAlive: true,
      nav_id: '',
    }
  },
  methods: {
    callbackComponent (params) {
      params.function && this[params.function](params.data)
    },
    getBannerList (data) {
      this.banner = data.image
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }

}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/service/index.vue